import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import TerrainFibre from "@/pages/TerrainFibre";
import Qualite from "@/pages/Qualite";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Realisations from "@/pages/Realisations";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import SousTraitance from "@/pages/SousTraitance";
import FtthD3 from "@/pages/FtthD3";
import ZonesIntervention from "@/pages/ZonesIntervention";
import Guides from "@/pages/Guides";
import Article from "@/pages/Article";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terrain-fibre" element={<TerrainFibre />} />
            <Route path="/qualite-controle" element={<Qualite />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/sous-traitance-fibre-optique" element={<SousTraitance />} />
            <Route path="/raccordement-ftth-d3" element={<FtthD3 />} />
            <Route path="/zones-intervention" element={<ZonesIntervention />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/:slug" element={<Article />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
